export default __webpack_public_path__ + "static/1099-594b34542b2b44d7f02b3e075a598870.gif";